import SelectDropdown from 'src/components/atomsLegacy/SelectDropdown/SelectDropdown';
import styled from 'styled-components';

export const ConfigurationsContainer = styled.div`
  height: 100%;
  overflow: scroll;
  background: ${(props) => props.theme.atlas.semantic.color.surface.variant};
  padding: 20px;
  display: flex;
  flex-direction: column;

  & > div {
    margin-bottom: 40px;
  }
`;

export const RoutingCheckboxContainer = styled.div`
  margin-top: 8px;
`;

export const StyledRoutingDropdown = styled(SelectDropdown)`
  max-width: 200px;
`;

export const LogoImageSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media screen and (min-width: 0px) and (max-width: 900px) {
    align-items: flex-start;
    width: 100%;
  }
`;

export const LogoImage = styled.img`
  max-width: 175px;
  margin-bottom: ${(props) => props.theme.spacing() * 3}px;
`;

export const FilepondContainer = styled.div`
  min-width: 400px;

  @media screen and (min-width: 0px) and (max-width: 900px) {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 160px;
`;

export const HotlineNumbers = styled.div`
  min-width: 600px;
  display: flex;
  justify-content: flex-end;

  & .country {
    display: flex;
    align-items: center;
    gap: 13px;
  }
  & .fi {
    aspect-ratio: 4/3;
    width: 38px;
  }

  & th .language-column {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  & th .language-column .uil {
    cursor: pointer;
  }

  .copy-button {
    min-width: 53px;
  }

  @media screen and (min-width: 0px) and (max-width: 900px) {
    max-width: 100%;
    justify-content: flex-start;
  }
`;
